
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M1.337 11.095c0-.255.103-.498.286-.675l.688-.665c.262-.253.41-.601.409-.965l-.007-2.108a5.329 5.329 0 1110.657-.016v2.14c0 .354.141.694.392.945l.668.668a.945.945 0 01-.668 1.614h-3.066a2.674 2.674 0 11-5.348 0H2.276a.939.939 0 01-.94-.938zm5.348.938a1.337 1.337 0 102.674 0H6.685zm5.348-3.227c0 .709.282 1.389.783 1.89H3.261c.51-.504.798-1.192.796-1.91L4.05 6.678a3.992 3.992 0 117.983-.012v2.14z","fill":"currentColor"}})])
          )
        }
      }
    